import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    currencyMapper,
    doesPropExistAndHasItChanged
} from '@nexio/emvio-util-app';
import { connect } from 'react-redux';
import './ResellerWidgetSettings.scss';
import { updateSettings } from './resellerWidgetSettingsActions';
import { getResellerWidgetSettingsEntity } from './resellerWidgetSettingsEntity';
import { EmvioSelect } from '@nexio/emvio-form-components';
import _ from 'lodash';
import { getMerchants } from '../../../Merchants/merchantsEntity';

export class ResellerWidgetSettings extends Component {
    static propTypes = {
        allMerchants: PropTypes.array,
        onUpdateSettings: PropTypes.func,
        settings: PropTypes.shape({
            currencyId: PropTypes.string,
            currencyCode: PropTypes.string
        })
    };

    constructor(props) {
        super(props);

        this.state = {
            shouldRenderCurrencySelect: false,
            merchantMapper: {}
        };
    }

    componentDidMount() {
        this.generateMapper(this.props.allMerchants);
    }

    componentDidUpdate(previousProps) {
        if (doesPropExistAndHasItChanged(previousProps, this.props, 'allMerchants')) {
            this.generateMapper(this.props.allMerchants);
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'settings')) {
            const currencyFilterValue = _.get(this.props.settings, 'currencyId');
            if (currencyFilterValue) {
                this.setState({ currencyFilter: { value: currencyFilterValue } });
            }
        }
    }

    generateMapper = (merchants) => {

        const allowedCurrencies = _.uniqWith(_.map(merchants, 'currencyId'), _.isEqual);

        const currenciesInMerchantsWidget = _.filter(currencyMapper, (currency, index) => {
            currency.id = index;

            return _.includes(allowedCurrencies, index);
        });

        const merchantMapper = _.reduce(currenciesInMerchantsWidget, (acc, currencyKey) => {
            acc[currencyKey.id] = currencyKey;

            return acc;
        }, {});

        const currencyKeys = Object.keys(merchantMapper);

        const lastValue = _.get(this.props, 'settings.currencyId', '840');
        const newValue = _.find(currencyKeys, (key) => _.isEqual(key, lastValue)) || currencyKeys[0];
        const shouldRenderCurrencySelect = currencyKeys.length > 1;

        this.setState({ shouldRenderCurrencySelect, merchantMapper, currencyValue: newValue });

        const newSettings = {
            ...this.props.settings,
            currencyId: newValue
        };
        this.props.onUpdateSettings(newSettings);
    };

    handleCurrencyChange = (newId) => {
        if (this.state.merchantMapper[newId]) {
            const newCurrency = this.state.merchantMapper[newId];

            const settings = {
                ...this.props.settings,
                currencyId: newCurrency.id,
                currencyCode: _.toUpper(newCurrency.code)
            };
            this.props.onUpdateSettings(settings);
        }

    };

    render() {
        const currencyId = _.get(this.props, 'settings.currencyId') || '840';
        const currencyOptions = _.map(this.state.merchantMapper, (currency, key) => {
            return {
                label: `${_.toUpper(currency.code)} - (${currency.symbol})`,
                value: key
            };
        });
        const defaultCurrency = currencyOptions.find((currencyOptions) => currencyOptions.value === currencyId);

        if (!_.isEmpty(currencyOptions)) {
            return (
                <div className="widget-settings">
                    <EmvioSelect className="currency-selector"
                        label="CURRENCY"
                        options={currencyOptions}
                        onChange={this.handleCurrencyChange}
                        defaultSelectedOption={defaultCurrency}
                    />
                </div>
            );
        } else {
            return (<div className="widget-settings"></div>);
        }
    }
}

function mapStateToProps(state, ownProps) {
    return {
        settings: getResellerWidgetSettingsEntity(state),
        allMerchants: getMerchants(state)
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onUpdateSettings: (settings) => dispatch(updateSettings(settings))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResellerWidgetSettings);
